import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Button, HStack, useMediaQuery, VStack } from "@chakra-ui/react";
import { ChevronLeftIcon } from "@chakra-ui/icons";
import { height, width } from "@fortawesome/free-solid-svg-icons/fa0";

const ResponsiveNav = ({ showBackButton = false }) => {
  const [isLargerThan768] = useMediaQuery("(min-width: 768px)");
  const { pedidoActual, user } = useSelector((state) => state);
  const navigate = useNavigate();
  const location = useLocation();
  const [showTopNav, setShowNav] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);


 

  const handleBack = () => {
    navigate(-1);
  };

  const totalQuantity = pedidoActual?.attributes?.pedido_articulos?.reduce(
    (sum, item) => {
      const quantity = parseInt(item.quantity) || 0;
      return sum + quantity;
    },
    0
  );
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        // Scrolling down
        setShowNav(false);
      } else {
        // Scrolling up
        setShowNav(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  const styles = {
    nav: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#fff",
      padding: ".5rem",
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
    },
    logoContainer: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "1rem",
    },
    desktopMenu: {
      display: "flex",
      justifyContent: "space-between",
      gap: "2rem",
      width: "100%",
      padding: "0 1rem",
    },
    mobileMenu: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      position: "fixed",
      bottom: 0,
      left: 0,
      backgroundColor: "#fff",
      padding: "0.5rem .5rem",
      height: "80px",
      zIndex: "99999",
    },
    navItem: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "0.5rem",
      borderRadius: "12px",
      textDecoration: "none",
      color: "#1C1B1F",
    },
    cartContainer: {
      // position: "absolute",
      // top: "1rem",
      // right: "1rem",
      width: "75px",
      display: "flex",
      justifyContent: "flex-end",
    },
    cartLink: {
      display: "flex",
      alignItems: "center",
      textDecoration: "none",
    },
    counter: {
      backgroundColor: "red",
      borderRadius: "50%",
      padding: "1px 8px",
      color: "white",
      fontWeight: "bold",
      marginLeft: "0.5rem",
    },
    button: {
      backgroundColor: "transparent",
    },
  };
  const topNavStyle = {
    ...styles.nav,
    transform: showTopNav ? "translateY(0)" : "translateY(-100%)",
    transition: "transform 0.3s ease-in-out",
  };
  const carrito = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18C4 17.45 4.19583 16.9792 4.5875 16.5875C4.97917 16.1958 5.45 16 6 16C6.55 16 7.02083 16.1958 7.4125 16.5875C7.80417 16.9792 8 17.45 8 18C8 18.55 7.80417 19.0208 7.4125 19.4125C7.02083 19.8042 6.55 20 6 20ZM16 20C15.45 20 14.9792 19.8042 14.5875 19.4125C14.1958 19.0208 14 18.55 14 18C14 17.45 14.1958 16.9792 14.5875 16.5875C14.9792 16.1958 15.45 16 16 16C16.55 16 17.0208 16.1958 17.4125 16.5875C17.8042 16.9792 18 17.45 18 18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20ZM5.15 4L7.55 9H14.55L17.3 4H5.15ZM4.2 2H18.95C19.3333 2 19.625 2.17083 19.825 2.5125C20.025 2.85417 20.0333 3.2 19.85 3.55L16.3 9.95C16.1167 10.2833 15.8708 10.5417 15.5625 10.725C15.2542 10.9083 14.9167 11 14.55 11H7.1L6 13H18V15H6C5.25 15 4.68333 14.6708 4.3 14.0125C3.91667 13.3542 3.9 12.7 4.25 12.05L5.6 9.6L2 2H0V0H3.25L4.2 2Z"
        fill="#1C1B1F"
      />
    </svg>
  );

  const Logo = (
    <svg
      width="107"
      height="40"
      viewBox="0 0 107 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.47874 33.11L13.612 17.8813C9.55277 19.9764 8.10148 16.3536 7.88324 14.2804H14.2667L18.6861 11.8252L31.6167 19.6818L29.8162 24.2648H23.2691C22.8454 25.2181 21.9317 32.0979 30.3507 35.0239"
        stroke="#CA0017"
        strokeWidth="2.365"
      />
      <path
        d="M26.04 12.7755L24.2282 11.5677L26.3933 11.3357L29.1431 11.0411L30.0154 10.9476V11.825C30.0154 12.1396 29.9522 12.614 29.7388 13.0503C29.5171 13.5036 29.077 14.0071 28.3234 14.0825L28.0426 14.1106L27.8077 13.954L26.04 12.7755Z"
        stroke="#CA0017"
        strokeWidth="1.57666"
      />
      <circle
        cx="19.7083"
        cy="19.7083"
        r="18.5258"
        stroke="#CA0017"
        strokeWidth="2.365"
      />
      <path
        d="M46.4667 16C46.2252 16 46.1044 15.8763 46.1044 15.6289C46.1044 15.3167 46.1103 15.0075 46.1221 14.7012C46.1339 14.389 46.1427 14.0798 46.1486 13.7735C46.1604 13.0902 46.1692 12.4099 46.1751 11.7325C46.1869 11.0492 46.1928 10.3689 46.1928 9.69153C46.1928 9.03771 46.1898 8.38389 46.1839 7.73007C46.1781 7.07626 46.1692 6.42244 46.1574 5.76862C46.1515 5.47411 46.1427 5.17665 46.1309 4.87624C46.1191 4.57584 46.1133 4.27838 46.1133 3.98387C46.1133 3.73648 46.234 3.61278 46.4755 3.61278H49.7888C50.7783 3.61278 51.709 3.75415 52.5808 4.03688C53.4584 4.31961 54.2212 4.77022 54.8691 5.3887C55.5171 6.00128 55.9942 6.80825 56.3005 7.80959C56.5184 8.52821 56.6274 9.2586 56.6274 10.0008C56.6274 11.2083 56.3535 12.2626 55.8057 13.1638C55.2638 14.0592 54.5216 14.7572 53.5792 15.2578C52.6426 15.7526 51.5824 16 50.3984 16H46.4667ZM48.3751 13.8707H50.0097C51.3232 13.8707 52.3717 13.5261 53.1551 12.8369C53.9444 12.1419 54.339 11.1199 54.339 9.77105C54.339 9.00532 54.177 8.3191 53.8531 7.7124C53.5291 7.09982 53.0755 6.61682 52.4924 6.2634C51.9093 5.90998 51.226 5.73328 50.4426 5.73328H48.384C48.3898 6.35764 48.3928 6.98496 48.3928 7.61521C48.3987 8.24547 48.4016 8.87573 48.4016 9.50599C48.4016 10.955 48.3928 12.4099 48.3751 13.8707ZM62.6393 16.212C61.7793 16.212 61.0283 16.0412 60.3863 15.6996C59.7502 15.358 59.2554 14.872 58.902 14.2418C58.5485 13.6115 58.3718 12.8634 58.3718 11.9976C58.3718 11.1906 58.5397 10.4661 58.8755 9.82406C59.2112 9.18202 59.6854 8.67546 60.2979 8.30438C60.9105 7.9274 61.6291 7.73891 62.4538 7.73891C63.4728 7.73891 64.2709 8.02459 64.8482 8.59594C65.4313 9.1673 65.826 9.92714 66.0321 10.8755C66.038 10.8931 66.041 10.9226 66.041 10.9638C66.041 11.0522 66.0174 11.1199 65.9703 11.167C65.929 11.2083 65.8731 11.2436 65.8024 11.2731C65.6021 11.3673 65.3901 11.4498 65.1662 11.5205C64.9424 11.5911 64.7245 11.6677 64.5124 11.7502C63.894 11.9799 63.2725 12.2067 62.6482 12.4305C62.0238 12.6484 61.4053 12.8811 60.7927 13.1285C60.7456 13.1521 60.722 13.1815 60.722 13.2169C60.722 13.2345 60.7279 13.2551 60.7397 13.2787C60.9753 13.7028 61.2993 14.0179 61.7116 14.2241C62.1239 14.4302 62.5657 14.5333 63.0369 14.5333C63.408 14.5333 63.7526 14.4744 64.0707 14.3566C64.3946 14.2388 64.7127 14.0916 65.0249 13.9148C65.0661 13.8913 65.1073 13.8707 65.1486 13.853C65.1898 13.8353 65.231 13.8265 65.2723 13.8265C65.3547 13.8265 65.4166 13.853 65.4578 13.906C65.5049 13.9531 65.5432 14.0091 65.5727 14.0739C65.5962 14.1151 65.6404 14.2094 65.7052 14.3566C65.7759 14.498 65.8407 14.6423 65.8996 14.7896C65.9644 14.9309 65.9968 15.0222 65.9968 15.0634C65.9968 15.1282 65.9791 15.1813 65.9438 15.2225C65.9084 15.2637 65.8672 15.302 65.8201 15.3373C65.4019 15.626 64.8924 15.8439 64.2915 15.9912C63.6966 16.1384 63.1459 16.212 62.6393 16.212ZM60.4216 11.9092C61.0166 11.7031 61.6115 11.4969 62.2064 11.2907C62.8013 11.0846 63.3933 10.8784 63.9823 10.6723C63.835 10.3483 63.6289 10.0656 63.3638 9.82406C63.1047 9.58256 62.7836 9.46181 62.4008 9.46181C61.9531 9.46181 61.582 9.58256 61.2875 9.82406C60.993 10.0656 60.7751 10.3748 60.6337 10.7518C60.4923 11.1229 60.4216 11.5087 60.4216 11.9092ZM45.539 23.9839C45.539 23.7365 45.6597 23.6128 45.9012 23.6128H53.3936C53.6351 23.6128 53.7559 23.7365 53.7559 23.9839C53.7559 24.2136 53.7559 24.4492 53.7559 24.6907C53.7618 24.9263 53.7559 25.159 53.7382 25.3887C53.7205 25.6243 53.5998 25.7421 53.3759 25.7421H50.8137C50.743 25.7421 50.7077 25.7775 50.7077 25.8481C50.7077 26.4725 50.7047 27.0969 50.6988 27.7212C50.6988 28.3397 50.6988 28.9611 50.6988 29.5855C50.6988 30.5927 50.7018 31.6029 50.7077 32.616C50.7136 33.6233 50.7165 34.6305 50.7165 35.6377C50.7165 35.8792 50.5957 36 50.3542 36H48.8257C48.5842 36 48.4635 35.8792 48.4635 35.6377C48.4635 34.6011 48.4664 33.5644 48.4723 32.5277C48.4841 31.491 48.49 30.4573 48.49 29.4265L48.4811 25.8481C48.4811 25.7775 48.4429 25.7421 48.3663 25.7421H45.9189C45.6951 25.7421 45.5743 25.6243 45.5566 25.3887C45.539 25.159 45.5301 24.9263 45.5301 24.6907C45.536 24.4492 45.539 24.2136 45.539 23.9839ZM59.6176 36.212C58.7576 36.212 58.0066 36.0412 57.3646 35.6996C56.7285 35.358 56.2337 34.872 55.8803 34.2418C55.5268 33.6115 55.3501 32.8634 55.3501 31.9976C55.3501 31.1906 55.518 30.4661 55.8537 29.8241C56.1895 29.182 56.6637 28.6755 57.2762 28.3044C57.8888 27.9274 58.6074 27.7389 59.4321 27.7389C60.4511 27.7389 61.2492 28.0246 61.8265 28.5959C62.4096 29.1673 62.8043 29.9271 63.0104 30.8755C63.0163 30.8931 63.0192 30.9226 63.0192 30.9638C63.0192 31.0522 62.9957 31.1199 62.9486 31.167C62.9073 31.2083 62.8514 31.2436 62.7807 31.2731C62.5804 31.3673 62.3684 31.4498 62.1445 31.5205C61.9207 31.5911 61.7028 31.6677 61.4907 31.7502C60.8722 31.9799 60.2508 32.2067 59.6265 32.4305C59.0021 32.6484 58.3836 32.8811 57.771 33.1285C57.7239 33.1521 57.7003 33.1815 57.7003 33.2169C57.7003 33.2345 57.7062 33.2551 57.718 33.2787C57.9536 33.7028 58.2776 34.0179 58.6899 34.2241C59.1022 34.4302 59.544 34.5333 60.0152 34.5333C60.3863 34.5333 60.7309 34.4744 61.049 34.3566C61.3729 34.2388 61.691 34.0916 62.0032 33.9148C62.0444 33.8913 62.0856 33.8707 62.1269 33.853C62.1681 33.8353 62.2093 33.8265 62.2506 33.8265C62.333 33.8265 62.3949 33.853 62.4361 33.906C62.4832 33.9531 62.5215 34.0091 62.551 34.0739C62.5745 34.1151 62.6187 34.2094 62.6835 34.3566C62.7542 34.498 62.819 34.6423 62.8779 34.7896C62.9427 34.9309 62.9751 35.0222 62.9751 35.0634C62.9751 35.1282 62.9574 35.1813 62.9221 35.2225C62.8867 35.2637 62.8455 35.302 62.7984 35.3373C62.3802 35.626 61.8706 35.8439 61.2698 35.9912C60.6749 36.1384 60.1242 36.212 59.6176 36.212ZM57.3999 31.9092C57.9949 31.7031 58.5898 31.4969 59.1847 31.2907C59.7796 31.0846 60.3716 30.8784 60.9606 30.6723C60.8133 30.3483 60.6072 30.0656 60.3421 29.8241C60.083 29.5826 59.7619 29.4618 59.3791 29.4618C58.9314 29.4618 58.5603 29.5826 58.2658 29.8241C57.9713 30.0656 57.7534 30.3748 57.612 30.7518C57.4706 31.1229 57.3999 31.5087 57.3999 31.9092ZM66.5219 27.9863C66.7458 27.9863 66.8665 28.0953 66.8842 28.3132L66.9726 29.3204C66.9726 29.3263 66.9784 29.3705 66.9902 29.453C67.002 29.5295 67.0226 29.5678 67.0521 29.5678C67.0815 29.5678 67.111 29.5354 67.1404 29.4706C67.1758 29.4059 67.1964 29.3676 67.2023 29.3558C67.4438 28.9022 67.7383 28.5459 68.0858 28.2867C68.4333 28.0275 68.8722 27.8979 69.4023 27.8979C69.526 27.8979 69.6821 27.9097 69.8706 27.9333C70.0649 27.951 70.1621 28.0481 70.1621 28.2249C70.1621 28.3132 70.1445 28.4516 70.1091 28.6401C70.0738 28.8286 70.0325 29.02 69.9854 29.2144C69.9442 29.4029 69.9118 29.5472 69.8882 29.6474C69.8647 29.7475 69.8264 29.827 69.7734 29.8859C69.7263 29.9389 69.6438 29.9654 69.526 29.9654C69.4671 29.9654 69.4082 29.9625 69.3493 29.9566C69.2963 29.9448 69.2374 29.9389 69.1726 29.9389C68.7072 29.9389 68.3155 30.0862 67.9975 30.3807C67.6794 30.6693 67.4408 31.0257 67.2818 31.4498C67.1228 31.8739 67.0432 32.2921 67.0432 32.7044V35.6377C67.0432 35.8792 66.9225 36 66.681 36H65.3115C65.07 36 64.9493 35.8763 64.9493 35.6289C64.9493 34.7159 64.9522 33.8059 64.9581 32.8988C64.9699 31.9858 64.9758 31.0757 64.9758 30.1686V28.3486C64.9758 28.1071 65.0965 27.9863 65.338 27.9863H66.5219ZM73.1347 27.9863C73.3526 27.9863 73.4734 28.0923 73.497 28.3044C73.5146 28.4222 73.5294 28.54 73.5411 28.6578C73.5529 28.7756 73.5647 28.8934 73.5765 29.0112C73.5765 29.023 73.5824 29.0583 73.5941 29.1172C73.6059 29.1702 73.6265 29.1967 73.656 29.1967C73.6854 29.1967 73.712 29.1791 73.7355 29.1437C73.765 29.1084 73.7856 29.0819 73.7974 29.0642C74.1508 28.6107 74.5808 28.2838 75.0873 28.0835C75.5939 27.8832 76.127 27.7831 76.6865 27.7831C77.146 27.7831 77.5671 27.8803 77.95 28.0747C78.3388 28.2631 78.6509 28.5341 78.8865 28.8875C79.1222 29.235 79.24 29.6503 79.24 30.1333C79.24 31.0463 79.2488 31.9622 79.2665 32.8811C79.29 33.8 79.3018 34.7159 79.3018 35.6289C79.3018 35.8763 79.1811 36 78.9396 36H77.5524C77.3286 36 77.2078 35.8792 77.1902 35.6377C77.1725 35.3845 77.1666 35.1312 77.1725 34.8779C77.1784 34.6187 77.1784 34.3625 77.1725 34.1092C77.1666 33.5673 77.1636 33.0284 77.1636 32.4924C77.1636 31.9563 77.1636 31.4203 77.1636 30.8843C77.1636 30.4661 77.0429 30.1539 76.8014 29.9478C76.5599 29.7357 76.2389 29.6297 75.8383 29.6297C75.3377 29.6297 74.9253 29.7828 74.6014 30.0891C74.2833 30.3954 74.0448 30.7724 73.8857 31.2201C73.7326 31.6677 73.656 32.1065 73.656 32.5365C73.656 33.0549 73.6531 33.5732 73.6472 34.0916C73.6413 34.604 73.6354 35.1194 73.6295 35.6377C73.6295 35.8792 73.5087 36 73.2672 36H71.8801C71.6386 36 71.5178 35.8763 71.5178 35.6289C71.5178 35.2991 71.5208 34.9721 71.5267 34.6482C71.5384 34.3183 71.5473 33.9914 71.5532 33.6675C71.5708 32.2891 71.5797 30.9108 71.5797 29.5325V28.3486C71.5797 28.1071 71.7004 27.9863 71.9419 27.9863H73.1347ZM85.4728 36.212C84.6128 36.212 83.8618 36.0412 83.2198 35.6996C82.5836 35.358 82.0888 34.872 81.7354 34.2418C81.382 33.6115 81.2053 32.8634 81.2053 31.9976C81.2053 31.1906 81.3732 30.4661 81.7089 29.8241C82.0447 29.182 82.5188 28.6755 83.1314 28.3044C83.744 27.9274 84.4626 27.7389 85.2873 27.7389C86.3063 27.7389 87.1044 28.0246 87.6816 28.5959C88.2648 29.1673 88.6594 29.9271 88.8656 30.8755C88.8715 30.8931 88.8744 30.9226 88.8744 30.9638C88.8744 31.0522 88.8509 31.1199 88.8037 31.167C88.7625 31.2083 88.7066 31.2436 88.6359 31.2731C88.4356 31.3673 88.2236 31.4498 87.9997 31.5205C87.7759 31.5911 87.558 31.6677 87.3459 31.7502C86.7274 31.9799 86.106 32.2067 85.4816 32.4305C84.8573 32.6484 84.2388 32.8811 83.6262 33.1285C83.5791 33.1521 83.5555 33.1815 83.5555 33.2169C83.5555 33.2345 83.5614 33.2551 83.5732 33.2787C83.8088 33.7028 84.1328 34.0179 84.5451 34.2241C84.9574 34.4302 85.3992 34.5333 85.8704 34.5333C86.2415 34.5333 86.5861 34.4744 86.9041 34.3566C87.2281 34.2388 87.5462 34.0916 87.8584 33.9148C87.8996 33.8913 87.9408 33.8707 87.9821 33.853C88.0233 33.8353 88.0645 33.8265 88.1057 33.8265C88.1882 33.8265 88.2501 33.853 88.2913 33.906C88.3384 33.9531 88.3767 34.0091 88.4062 34.0739C88.4297 34.1151 88.4739 34.2094 88.5387 34.3566C88.6094 34.498 88.6742 34.6423 88.7331 34.7896C88.7979 34.9309 88.8303 35.0222 88.8303 35.0634C88.8303 35.1282 88.8126 35.1813 88.7772 35.2225C88.7419 35.2637 88.7007 35.302 88.6535 35.3373C88.2353 35.626 87.7258 35.8439 87.125 35.9912C86.5301 36.1384 85.9794 36.212 85.4728 36.212ZM83.2551 31.9092C83.85 31.7031 84.445 31.4969 85.0399 31.2907C85.6348 31.0846 86.2268 30.8784 86.8158 30.6723C86.6685 30.3483 86.4624 30.0656 86.1973 29.8241C85.9381 29.5826 85.6171 29.4618 85.2342 29.4618C84.7866 29.4618 84.4155 29.5826 84.121 29.8241C83.8265 30.0656 83.6085 30.3748 83.4672 30.7518C83.3258 31.1229 83.2551 31.5087 83.2551 31.9092ZM92.3771 27.9863C92.601 27.9863 92.7217 28.0953 92.7394 28.3132L92.8277 29.3204C92.8277 29.3263 92.8336 29.3705 92.8454 29.453C92.8572 29.5295 92.8778 29.5678 92.9073 29.5678C92.9367 29.5678 92.9662 29.5354 92.9956 29.4706C93.0309 29.4059 93.0516 29.3676 93.0575 29.3558C93.299 28.9022 93.5935 28.5459 93.941 28.2867C94.2885 28.0275 94.7273 27.8979 95.2575 27.8979C95.3812 27.8979 95.5373 27.9097 95.7257 27.9333C95.9201 27.951 96.0173 28.0481 96.0173 28.2249C96.0173 28.3132 95.9996 28.4516 95.9643 28.6401C95.929 28.8286 95.8877 29.02 95.8406 29.2144C95.7994 29.4029 95.767 29.5472 95.7434 29.6474C95.7199 29.7475 95.6816 29.827 95.6286 29.8859C95.5814 29.9389 95.499 29.9654 95.3812 29.9654C95.3223 29.9654 95.2634 29.9625 95.2045 29.9566C95.1514 29.9448 95.0925 29.9389 95.0277 29.9389C94.5624 29.9389 94.1707 30.0862 93.8526 30.3807C93.5346 30.6693 93.296 31.0257 93.137 31.4498C92.9779 31.8739 92.8984 32.2921 92.8984 32.7044V35.6377C92.8984 35.8792 92.7777 36 92.5362 36H91.1667C90.9252 36 90.8044 35.8763 90.8044 35.6289C90.8044 34.7159 90.8074 33.8059 90.8133 32.8988C90.825 31.9858 90.8309 31.0757 90.8309 30.1686V28.3486C90.8309 28.1071 90.9517 27.9863 91.1932 27.9863H92.3771ZM100.536 36.1679C99.7703 36.1679 99.1283 35.9853 98.61 35.6201C98.0916 35.2549 97.6999 34.7719 97.4349 34.1711C97.1757 33.5644 97.0461 32.9076 97.0461 32.2008V32.0594C97.0579 31.3172 97.211 30.6192 97.5055 29.9654C97.8059 29.3116 98.2389 28.7844 98.8043 28.3839C99.3698 27.9775 100.053 27.7743 100.854 27.7743C101.349 27.7743 101.808 27.8685 102.232 28.057C102.662 28.2396 103.063 28.4899 103.434 28.808C103.475 28.8492 103.511 28.8698 103.54 28.8698C103.611 28.8698 103.643 28.7962 103.637 28.649C103.637 28.5017 103.658 28.3544 103.699 28.2072C103.746 28.0599 103.864 27.9863 104.053 27.9863H105.298C105.54 27.9863 105.661 28.1071 105.661 28.3486C105.661 28.6018 105.658 28.8551 105.652 29.1084C105.652 29.3617 105.652 29.615 105.652 29.8682C105.652 30.5162 105.655 31.167 105.661 31.8209C105.672 32.4747 105.681 33.1256 105.687 33.7735C105.693 34.0798 105.699 34.389 105.705 34.7012C105.717 35.0075 105.722 35.3167 105.722 35.6289C105.722 35.8763 105.602 36 105.36 36H103.973C103.814 36 103.711 35.9499 103.664 35.8498C103.617 35.7438 103.596 35.6201 103.602 35.4787C103.608 35.3373 103.608 35.2107 103.602 35.0988C103.602 35.0811 103.599 35.0517 103.593 35.0104C103.587 34.9692 103.57 34.9486 103.54 34.9486C103.517 34.9486 103.493 34.9574 103.469 34.9751C103.452 34.9928 103.434 35.0075 103.416 35.0193C103.004 35.3668 102.559 35.6466 102.082 35.8586C101.605 36.0648 101.09 36.1679 100.536 36.1679ZM101.437 34.2859C101.855 34.2859 102.241 34.2005 102.595 34.0297C102.954 33.853 103.234 33.5762 103.434 33.1992C103.446 33.1756 103.472 33.1167 103.514 33.0225C103.561 32.9223 103.584 32.8605 103.584 32.8369C103.584 32.6308 103.581 32.4246 103.575 32.2185C103.575 32.0123 103.575 31.8091 103.575 31.6088C103.575 31.5146 103.578 31.4115 103.584 31.2996C103.59 31.1818 103.587 31.0787 103.575 30.9903C103.57 30.9491 103.546 30.8873 103.505 30.8048C103.469 30.7223 103.443 30.6634 103.425 30.6281C103.219 30.257 102.928 29.9802 102.551 29.7976C102.174 29.615 101.779 29.5237 101.367 29.5237C100.931 29.5237 100.548 29.6326 100.218 29.8506C99.8882 30.0685 99.629 30.3571 99.4405 30.7164C99.2579 31.0699 99.1666 31.4586 99.1666 31.8827C99.1666 32.3068 99.2638 32.7015 99.4582 33.0667C99.6525 33.4318 99.9205 33.7264 100.262 33.9502C100.61 34.174 101.001 34.2859 101.437 34.2859Z"
        fill="#3D3D3D"
      />
    </svg>
  );

  const home = (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 16H5V10H11V16H14V7L8 2.5L2 7V16ZM0 18V6L8 0L16 6V18H9V12H7V18H0Z"
        fill="#1C1B1F"
      />
    </svg>
  );

  const search = (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6 18L10.3 11.7C9.8 12.1 9.225 12.4167 8.575 12.65C7.925 12.8833 7.23333 13 6.5 13C4.68333 13 3.14583 12.3708 1.8875 11.1125C0.629167 9.85417 0 8.31667 0 6.5C0 4.68333 0.629167 3.14583 1.8875 1.8875C3.14583 0.629167 4.68333 0 6.5 0C8.31667 0 9.85417 0.629167 11.1125 1.8875C12.3708 3.14583 13 4.68333 13 6.5C13 7.23333 12.8833 7.925 12.65 8.575C12.4167 9.225 12.1 9.8 11.7 10.3L18 16.6L16.6 18ZM6.5 11C7.75 11 8.8125 10.5625 9.6875 9.6875C10.5625 8.8125 11 7.75 11 6.5C11 5.25 10.5625 4.1875 9.6875 3.3125C8.8125 2.4375 7.75 2 6.5 2C5.25 2 4.1875 2.4375 3.3125 3.3125C2.4375 4.1875 2 5.25 2 6.5C2 7.75 2.4375 8.8125 3.3125 9.6875C4.1875 10.5625 5.25 11 6.5 11Z"
        fill="#1C1B1F"
      />
    </svg>
  );

  const help = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.95 16C10.3 16 10.5958 15.8792 10.8375 15.6375C11.0792 15.3958 11.2 15.1 11.2 14.75C11.2 14.4 11.0792 14.1042 10.8375 13.8625C10.5958 13.6208 10.3 13.5 9.95 13.5C9.6 13.5 9.30417 13.6208 9.0625 13.8625C8.82083 14.1042 8.7 14.4 8.7 14.75C8.7 15.1 8.82083 15.3958 9.0625 15.6375C9.30417 15.8792 9.6 16 9.95 16ZM9.05 12.15H10.9C10.9 11.6 10.9625 11.1667 11.0875 10.85C11.2125 10.5333 11.5667 10.1 12.15 9.55C12.5833 9.11667 12.925 8.70417 13.175 8.3125C13.425 7.92083 13.55 7.45 13.55 6.9C13.55 5.96667 13.2083 5.25 12.525 4.75C11.8417 4.25 11.0333 4 10.1 4C9.15 4 8.37917 4.25 7.7875 4.75C7.19583 5.25 6.78333 5.85 6.55 6.55L8.2 7.2C8.28333 6.9 8.47083 6.575 8.7625 6.225C9.05417 5.875 9.5 5.7 10.1 5.7C10.6333 5.7 11.0333 5.84583 11.3 6.1375C11.5667 6.42917 11.7 6.75 11.7 7.1C11.7 7.43333 11.6 7.74583 11.4 8.0375C11.2 8.32917 10.95 8.6 10.65 8.85C9.91667 9.5 9.46667 9.99167 9.3 10.325C9.13333 10.6583 9.05 11.2667 9.05 12.15ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
        fill="#1C1B1F"
      />
    </svg>
  );
  const perfil = (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM0 16V13.2C0 12.6333 0.145833 12.1125 0.4375 11.6375C0.729167 11.1625 1.11667 10.8 1.6 10.55C2.63333 10.0333 3.68333 9.64583 4.75 9.3875C5.81667 9.12917 6.9 9 8 9C9.1 9 10.1833 9.12917 11.25 9.3875C12.3167 9.64583 13.3667 10.0333 14.4 10.55C14.8833 10.8 15.2708 11.1625 15.5625 11.6375C15.8542 12.1125 16 12.6333 16 13.2V16H0ZM2 14H14V13.2C14 13.0167 13.9542 12.85 13.8625 12.7C13.7708 12.55 13.65 12.4333 13.5 12.35C12.6 11.9 11.6917 11.5625 10.775 11.3375C9.85833 11.1125 8.93333 11 8 11C7.06667 11 6.14167 11.1125 5.225 11.3375C4.30833 11.5625 3.4 11.9 2.5 12.35C2.35 12.4333 2.22917 12.55 2.1375 12.7C2.04583 12.85 2 13.0167 2 13.2V14ZM8 6C8.55 6 9.02083 5.80417 9.4125 5.4125C9.80417 5.02083 10 4.55 10 4C10 3.45 9.80417 2.97917 9.4125 2.5875C9.02083 2.19583 8.55 2 8 2C7.45 2 6.97917 2.19583 6.5875 2.5875C6.19583 2.97917 6 3.45 6 4C6 4.55 6.19583 5.02083 6.5875 5.4125C6.97917 5.80417 7.45 6 8 6Z"
        fill="#1C1B1F"
      />
    </svg>
  );
  const NavItem = ({ to, label, icon }) => {
    // Obtener el prop 'to' correctamente
    const isLoginButton = to === "/UserProfile" || to === "/Login";
    const isAuthenticated = user?.username;
  
    // CSS personalizado para la animación
    const style = {
      animation: !isAuthenticated && isLoginButton ? "pulse 2s infinite" : "none",
      transition: "all 0.3s ease"
    };
  
    return (
      <NavLink
        to={isLoginButton ? (isAuthenticated ? "/UserProfile" : "/Login") : to}
        style={({ isActive }) => ({
          ...styles.contBut,
          backgroundColor: isActive ? "#FCF2F3" : "white",
          padding: ".5rem",
          fontWeight: isActive ? "700" : "400",
          textWrap: "nowrap",
          display: "flex",
          flexDirection: "column-reverse",
          alignItems: "center",
          borderRadius: "18px",
          width: "80px",
          ...style
        })}
        className={!isAuthenticated && isLoginButton ? "pulse-button" : ""}
      >
        {({ isActive }) => (
          <>
            <label
              htmlFor="text"
              style={{
                ...styles.label,
                color: !isAuthenticated && isLoginButton ? "#CA0017" : "#1C1B1F"
              }}
            >
              {isLoginButton ? (isAuthenticated ? user.username?.split(" ")[0] : "LogIn") : label}
            </label>
            <Button style={styles.button}>{icon}</Button>
          </>
        )}
      </NavLink>
    );
  };

  const isProdDetallePage = location.pathname.startsWith("/ProdDetalle/");

  return (
    <>
      <nav style={topNavStyle}>
        {!isLargerThan768 && (
          <div
            style={{
              display: showBackButton && !isLargerThan768 ? "flex" : "none",
            }}
          >
            <Button
              onClick={handleBack}
              leftIcon={<ChevronLeftIcon />}
              bg="transparent"
              padding=".5rem"
            >
              Atrás
            </Button>
          </div>
        )}

        <div style={styles.logoContainer}>
          <NavLink to="/">{Logo}</NavLink>
        </div>

        {isLargerThan768 ? (
          <div style={styles.desktopMenu}>
            <HStack padding={0}>
              <NavItem
                to="/"
                label="Inicio"
                icon={home}
                width={"80px"}
                id="navHome"
              />
              <NavItem
                to="/catfull"
                label="Catálogo"
                icon={search}
                width={"80px"}
                id="navCatalogo"
              />
              <NavItem
                to="/Ayuda"
                label="Ayuda"
                icon={help}
                width={"80px"}
                id="navAyuda"
              />
            </HStack>
            <HStack>
              <NavItem
                to={user?.username ? "/UserProfile" : "/Login"}
                label={user?.username ? user.username?.split(" ")[0] : "LogIn"}
                icon={perfil}
              />
            </HStack>
          </div>
        ) : null}

        <div style={styles.cartContainer}>
          {user?.username && (
            <NavLink to="/carrito" style={styles.cartLink} id="navCarrito">
              {carrito}
              <span style={styles.counter}>{totalQuantity || 0}</span>
            </NavLink>
          )}
        </div>
      </nav>

      {!isLargerThan768 && !isProdDetallePage && (
        <div style={styles.mobileMenu}>
          <NavItem to="/" label="Inicio" icon={home} />
          <NavItem to="/catfull" label="Catálogo" icon={search} />
          <NavItem to="/Ayuda" label="Ayuda" icon={help} />
          <NavItem
            to={user?.username ? "/UserProfile" : "/Login"}
            label={user?.username ? user.username?.split(" ")[0] : "LogIn"}
            icon={perfil}
          />
        </div>
      )}
    </>
  );
};

export default ResponsiveNav;
